import React from 'react';
import { ReactNode } from 'react';

import styles from './Alert.module.scss';

type AlertProps = {
  children?: ReactNode;
  success?: boolean;
  warning?: boolean;
  danger?: boolean;
  purple?: boolean;
  className?: string;
};

function Alert({
  success,
  warning,
  danger,
  children,
  className,
  purple,
}: AlertProps) {
  const _className = [styles.Alert];
  success && _className.push(styles.Alert__success);
  warning && _className.push(styles.Alert__warning);
  danger && _className.push(styles.Alert__danger);
  purple && _className.push(styles.Alert__purple);
  !success &&
    !warning &&
    !danger &&
    !purple &&
    _className.push(styles.Alert__primary);
  className && _className.push(className);

  return <div className={_className.join(' ')}>{children}</div>;
}

export default Alert;
